import Component from '../Component';
import { setCookie } from '../Helpers';
import $ from '../../vendor/CustomJquery';

export default class ElementSwitch extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-element-toggle', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let self = $(event.currentTarget),
        icon = self.find('.icon i'),
        target = $(self.data('target'));

    if (target.hasClass('is-hidden')) {
      target.removeClass('is-hidden');
      icon.removeClass('fa-angle-right').addClass('fa-angle-down');
    } else {
      target.addClass('is-hidden');
      icon.addClass('fa-angle-right').removeClass('fa-angle-down');
    }

    event.preventDefault();

  }

}